<template>
  <div class="q-ma-md">
    <div class="row q-gutter-md justify-center">
        <q-card class="my-card justify-center" flat>
        <q-card-section>
          <p class="text-h6 q-my-none">Plans</p>
          <h2 class="text-subtitle1 q-my-none">Grow your business and get more customers</h2>
        </q-card-section>
        </q-card>
    </div>
    <p>Scan balance: {{ store.getters.stateScansLeft }}</p>
    <div v-if="loading" class="q-pa-md row q-gutter-md justify-center"><Spinner/></div>
    <div v-else>
      <div class="q-col-gutter-y-lg">
        <div class="row q-ma-md" v-for="(plan, index) in plans" :key="index">
          <plan-card :plan="plan" :upgrade="upgrade"></plan-card>
        </div>
      </div>
    </div>

    <div class="justify-center">
      <div class="text-subtitle1 text-grey">Prices in AUD.</div>
      <q-img width="70%" class="paypal-welcome" src="/assets/paypal.png" />
    </div>
  </div>
</template>

<script>
import PlanCard from '@/components/PlanCard'
import Spinner from '@/components/Spinner'
import { ref } from '@vue/reactivity'
import router from "@/router"
import { useQuasar } from 'quasar'
import { inject } from 'vue'
import { useStore } from 'vuex'

export default {
  components: {PlanCard, Spinner},
  setup() {
    const plans = ref([])
    const dialog = ref(false)
    const confirm = ref(false)
    const choosedPlan = ref(null)
    const loading = ref(false)
    const page = ref(1)
    const axios = inject('axios')  // inject axios
    const $q = useQuasar()
    const store = useStore()
    const subscriptions = ref([])

    const getPlans = () => {
      loading.value = true
      axios.get(`${process.env.VUE_APP_URL}/plans?page=${page.value}&itemsPerPage=10&isActive=1`)
        .then(resp => {
          plans.value = resp.data.map(plan => {
            let currentPlan = subscriptions.value.filter(subs => subs.plan.id === plan.id && subs.status === 'ACTIVE')
            if (currentPlan.length > 0) {
              let scans_used = plan.scansIncluded - store.getters.stateScansLeft
              let progress = (scans_used > 0) ? scans_used / plan.scansIncluded : 0

              return {
                ...plan,
                current: true,
                scans_used: (scans_used && scans_used > 0) ? scans_used : 0,
                progress: progress ?? 0,
                subscription: currentPlan[0].id
              }
            }
            return plan
          })
        })
        .catch(err => {
          $q.notify({
            message: 'An error has ocurred!',
            caption: 'An error has when searching plans. Wait a few moments and try again.',
            color: 'negative'
          })
        })
        .finally(() => loading.value = false)
    }

    const getSubscriptions = async () => {
      axios.get(`${process.env.VUE_APP_URL}/subscriptions?page=1`)
        .then(resp => {
          subscriptions.value = resp.data
          getPlans()
        })
        .catch(err => {
          $q.notify({
            message: 'An error has ocurred!',
            caption: 'An error ocurred when getting plan. Wait a few moments and try again.',
            color: 'negative'
          })
        })
        .finally(() => loading.value = false)
    }

    const upgrade = async (plan) => {
      if (!plan.id) {
        $q.notify({
          message: 'Plan doesn\'t have a valid reference',
          caption: 'This plan does have a valid reference, please try again with another plan.',
          color: 'negative'
        })
      } else {
        axios.get(`${process.env.VUE_APP_URL}/paypal/subscribe/${plan.id}?successUrl=${window.location.origin}/thanks-page`)
        .then((resp)=>{
          window.open(resp.data.payLink, "_self")
        })
        .catch((err) => {
          loading.value = false
          $q.notify({
            message: 'An error has ocurred!',
            caption: 'An error ocurred when updating your current plan data. Wait a few moments and try again.',
            color: 'negative'
          })
        })
      }
    }

    store.dispatch('verifyLogged')
    .then(resp => {
      getSubscriptions()
    })
    .catch(error => {
      store.commit('setUser', null)
      store.commit('setClearHistory')
      store.commit('clearPlace')
      router.push('/')
    })

    return {plans, upgrade, confirm, dialog, choosedPlan, loading, store}
  },
}
</script>
<style scoped>
.paypal-welcome
{ width: 70%;
max-width: 300px}
</style>
